import CommonUiModel from "../common/commonUiModel";

const releaseManagementConfig = {
    title: "Release Management",
    api: 'Revision',
    relations: ["Document"],
    hideBreadcrumbInGrid: true,
    showHistory: false,
    defaultSort: "",
    permissions: { add: false, edit: true, delete: false },
    module: 'ReleaseMgmt',
    navigateBack: ({ searchParams, data }) => {
        if (searchParams.get('from') === 'releasemgmt') {
            return -1;
        }
        return `/release/${data.EquipmentId}`;
    },
    columns: [
        { field: 'Revision', label: 'Revision', readOnly: true, width: 180 },
        { field: 'RevisionStatusId', label: null, gridLabel: 'Status', lookup: 'RevisionStatus', type: 'select', dataIndex: 'RevisionStatus', width: 120 },
        { field: 'RevisionStatusId', label: 'Status', gridLabel: null, lookup: 'RevisionType', type: 'select', dataIndex: 'RevisionStatus', width: 120 },
        { field: 'Version', label: 'Version', width: 120 },
        { field: 'StagedRevision', label: 'Staged Revision', readOnly: true, width: 180 },
        { field: 'PlmReference', label: 'PLM ECN#', width: 150 },
        { field: 'Notes', label: 'Notes', multiline: true, width: 300 }
    ]
};
const ReleaseManagement = new CommonUiModel(releaseManagementConfig);
export { releaseManagementConfig };
export default ReleaseManagement;